import React from 'react';
import {useField, Field, FastField} from 'formik';
import { TextField } from "formik-mui";

const FullWidthText = ({...props}) => {
  const [field] = useField(props);
  const {fast, ...rest} = props;
  
  const fastField = (
      <FastField
          {...field}
          {...rest}
        component={TextField}
        type={"text"}
        fullWidth
      />
  );
  return !!fast ? fastField : (
    <Field
        {...field}
        {...props}
        component={TextField}
        type={"text"}
        fullWidth
    />
  );
};

export default FullWidthText;
